import { ClimEco, Ecler } from 'components';
import React from 'react';
import { APP_PROFILE } from 'utils/constants';

const PageHome = () => (
  APP_PROFILE === 'AFF' ? <ClimEco /> : <Ecler />
);

export default PageHome;